import * as React from "react";
import AuthService from '../../services/Auth';
import RegisterComplete from './RegisterComplete';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers';
import { TextField, Snackbar } from "@mui/material";
import Users from "../../models/Users";
import RestUtilities from "../../services/RestUtilities";
import Auth from "../../services/Auth";
import SnackbarWrapper from "../../components/SnackbarWrapper";
import Constants from '../../models/Constants' 
import { GrowMessage } from "../../components/GrowMessage";
import { withRouter } from "../../components/Shared/withNavigate";

let authStyle = require('../../styles/auth.styl');
let authService = new AuthService();


class Register extends React.Component<any, any> {

    private passwordConfirm: React.RefObject<HTMLInputElement>
    private consent: React.RefObject<HTMLInputElement>
    private conditions: React.RefObject<HTMLInputElement>

    constructor(props: any) {
        super(props)

        this.passwordConfirm = React.createRef()
        this.consent = React.createRef()
        this.conditions = React.createRef()
    }

    state = {
        registerComplete: false,
        user: new Users(),
        errors: {} as { [key: string]: string },
        validationFields: {
            firstname: true,
            lastname: true,
            email: true,
            phone: true
        } as { [key:string]: any },
        showMessage: false,
        message: ''
    };

    handleSubmit(event: React.MouseEvent<HTMLElement, MouseEvent>) {

        let isSignedIn: boolean = Auth.isSignedIn()
        if(!isSignedIn && this.consent.current.checked == false) {
            this.setState({ showMessage: true, message: 'DSGVO ist erforderlich' })
            return
        }

        if(!isSignedIn && this.conditions.current.checked == false) {
            this.setState({ showMessage: true, message: 'Teilnahmebedingungen ist erforderlich' })
            return
        }

        if(!isSignedIn && (this.state.user.password === '' || this.passwordConfirm.current.value === '')) {
            this.setState({ showMessage: true, message: 'Die Passwortfelder sind erforderlich!' })
            return
        }

        if(!isSignedIn && this.state.user.password !== this.passwordConfirm.current.value && this.state.user.password !== "" && this.state.user.password !== null) {
            this.setState({ showMessage: true, message: 'Die Passwortfelder müssen übereinstimmen!' })
            return
        }

        if(!this.validateUser())
            return

        let controllerName = 'register'

        if(isSignedIn)
            controllerName = 'users'

        RestUtilities.put<Users>(`api/${controllerName}/Edit`, this.state.user)
            .then(() => {
                this.props.router.navigate('/user/currentevents')
            }).catch(resp => {
                this.setState({ showMessage: true, message: resp.error_content })
            })
    }

    validateUser = (): boolean => {
        const user = this.state.user

        const validation = {...this.state.validationFields}

        let isValid: boolean = true

        let reEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        
        Object.keys(this.state.validationFields).map(x => {
            if(user[x] === '') {
                validation[x] = false
                isValid = false
            }

            if(x === 'email' && !reEmail.test(user[x])) {
                validation[x] = false
                isValid = false
            }
        })

        this.setState(() => ({
            validationFields: validation
        }))

        return isValid
    }

    handleUserChange = (event: any) => {
        let fieldName = event.target.name

        const newUser = {...this.state.user}
        newUser[fieldName] = event.target.value

        this.setState(() => ({
            user: newUser
        }))
    }

    _formGroupClass(field: string) {
        var className = "form-group ";
        if (field) {
            className += " has-danger"
        }
        return className;
    }

    componentDidMount() {
        let personalNr = window.localStorage.getItem("personalNr")
        RestUtilities.get<Users>(`/api/register?personalNr=${personalNr}`)
            .then(resp => {
                this.setState((state: any) => ({
                    user: resp.content
                }))
            })
    }

    handleSnackbarClose = (event: any, reason: string) => {
        if (reason === 'clickaway')
            return;

        this.setState({ showMessage:false })
    }

    render() {

        const isSignedIn: boolean = Auth.isSignedIn()

        if (this.state.registerComplete) {
            return <RegisterComplete />
        } else {
            return <main className={authStyle.main}>
               
                    
                    <Typography variant="h5" component="h3">
                            {!isSignedIn && `BMW - Veranstaltungen  Erstanmeldung`}
                            {isSignedIn && `Benutzer bearbeiten`}
                    </Typography>
                    <form className={authStyle.form} >
                          
                            <FormControl margin="normal" fullWidth>
                                <InputLabel htmlFor="personalNr">PersonalNr.</InputLabel>
                                <Input 
                                    id="personalNr" 
                                    name="personalNr" 
                                    value={typeof this.state.user.personalNr != 'undefined' ? this.state.user.personalNr : ''} 
                                    autoFocus  
                                    disabled/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="firstName">Vorname</InputLabel>
                                <Input 
                                    name="firstname" 
                                    type="text" 
                                    id="firstname"
                                    error={!this.state.validationFields.firstname}
                                    value={typeof this.state.user.firstname != 'undefined' ? this.state.user.firstname : ''}
                                    onChange={(e:any) => this.handleUserChange(e)}
                                    disabled={isSignedIn}
                                     />
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="secondName">Nachname</InputLabel>
                                <Input 
                                    name="lastname" 
                                    type="text" 
                                    id="lastname" 
                                    error={!this.state.validationFields.lastname}
                                    value={typeof this.state.user.lastname != 'undefined' ? this.state.user.lastname : ''}
                                    onChange={(e:any) => this.handleUserChange(e)} 
                                    disabled={isSignedIn}
                                    />
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="email">Email</InputLabel>
                                <Input 
                                    name="email" 
                                    type="email" 
                                    id="email" 
                                    error={!this.state.validationFields.email}
                                    value={typeof this.state.user.email != 'undefined' ? this.state.user.email : ''}
                                    onChange={(e:any) => this.handleUserChange(e)}
                                    disabled={isSignedIn}
                                    />
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="phone">Telefon</InputLabel>
                                <Input 
                                    name="phone" 
                                    type="text" 
                                    id="phone"
                                    error={!this.state.validationFields.phone}
                                    value={typeof this.state.user.phone != 'undefined' ? this.state.user.phone : ''}
                                    onChange={(e:any) => this.handleUserChange(e)} />
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                            <DatePicker 
                                    label='Geb. Datum *'
                                    className="margin-top-2"
                                    name='bithdate'
                                    disableFuture
                                    format={Constants.DateFormat}
                                    onChange={(e: any) => this.handleUserChange(e)}
                                    value={new Date(this.state.user.birthdate)}
                                    disabled={isSignedIn}
                                    />
                            </FormControl>
                    {
                        !isSignedIn &&
                        <>
                            <Checkbox style={{ color: 'rgb(0, 155, 229)', paddingLeft: 0 }} value="remember" color="primary" inputRef={this.consent} required />
                            <InputLabel>
                                <a href='Datenschutzerklärung_für_das_Anmeldesystem.pdf' target='_blank'>DSGVO</a> gelesen und bin Einverstanden *
                            </InputLabel>
                            <br />

                            <Checkbox style={{ color: 'rgb(0, 155, 229)', paddingLeft: 0 }} color="primary" inputRef={this.conditions} required />
                                <InputLabel>
                                    <a href='Teilnahmebedingungen_für_Veranstaltungen_des_BMW_Betriebsrates.pdf' target='_blank'>Teilnahmebedingungen</a> gelesen und bin Einverstanden *
                                </InputLabel>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="password">Passwort</InputLabel>
                                <Input
                                    name="password"
                                    type="password"
                                    id="password"
                                    onChange={(e:any) => this.handleUserChange(e)}
                                    value={this.state.user.password} />
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="repeatPassword">wiederholen</InputLabel>
                                <Input
                                    name="repeatPassword"
                                    type="password"
                                    id="repeatPassword"
                                    inputRef={this.passwordConfirm} />
                            </FormControl>
                        </>
                    }
                            <CssBaseline />
                            <div className='float-right'>* Pflichtfelder</div>
                            <Button 
                                type="button"
                                variant="contained"
                                color="primary"
                                className="btnBlue"
                                onClick={(e:any) => this.handleSubmit(e)}
                            >
                                Speichern
                            </Button>
                            </form>
                <GrowMessage
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    message={this.state.message}
                    visible={this.state.showMessage}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose} ></GrowMessage>  
                {/* <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.showMessage}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose}
                >
                    <SnackbarWrapper
                        onClose={this.handleSnackbarClose}
                        variant="success"
                        message={this.state.message}
                    />
                </Snackbar> */}
            </main>  
        };
    }
}

export default withRouter(Register);